import { biFunnelStages, formatBiFunnelRate } from '@euler/model/bi/funnel';
import { BiQueryResult } from '@euler/model/bi/result';
import { BiFunnelViz } from '@euler/model/bi/viz';
import { BiTableModel } from './biResultTable';

/**
 * A funnel's table: a row per stage with its value and its rates. Copies
 * carry the raw values and rates (fractions); stages do not add up, so the
 * totals row stays blank.
 */
export function biTableOfFunnel(
  viz: BiFunnelViz,
  result: BiQueryResult,
): BiTableModel {
  const stages = biFunnelStages(viz, result);
  const header = ['步骤', '数值', '较上一步', '占首步'];
  return {
    header,
    body: stages.map((stage, i) => [
      stage.label,
      stage.display,
      i ? formatBiFunnelRate(stage.stepRate) : '',
      i ? formatBiFunnelRate(stage.overallRate) : '',
    ]),
    raw: stages.map(stage => [
      stage.label,
      stage.value,
      stage.stepRate,
      stage.overallRate,
    ]),
    align: ['left', 'right', 'right', 'right'],
    totals: header.map(() => ''),
  };
}
